import React, { useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { DraftContent, IconPlusMinus, IconArrowHead } from '../../components';
import css from './ListingPage.module.css';
import classNames from 'classnames';

const SectionFAQ = props => {
  const { publicData = {}, locale, listingTranslation } = props;

  const { field_faq, faq } = publicData
  const [activeItem, setActiveItem] = useState(0);
  const [showSection, setShowSection] = useState(true);

  const handleSetActiveItem = (index) => {
    if (activeItem !== index) {
      setActiveItem(index)
    } else {
      setActiveItem(-1)
    }
  };

  const faqTranslated = listingTranslation?.[`faq_locale_${locale}`];
  const faqData = !!faqTranslated ? JSON.parse(faqTranslated) : faq;

  if(!field_faq && !faq) return null;
  
  return (
    <section className={css.section}>
      <h2 className={css.sectionTitle} onClick={() => setShowSection(!showSection)}>
        <FormattedMessage id="ListingPage.faq" />
        <IconArrowHead direction={showSection ? "up" : "down"} />
      </h2>

      {showSection && (
        <div className={css.faq}>

          {!!faqData?.length ? faqData.map((faq, i) => {
            const isActive = activeItem === i;
            return (
              <div key={faq.id} className={classNames(css.faqItem, isActive && css.faqItemActive)}>
                <h3 className={css.faqItemTitle} onClick={() => handleSetActiveItem(i)}>
                  {faq?.title}
                  <IconPlusMinus type={isActive ? "minus" : "plus"} />
                </h3>
                {isActive && (
                  <p className={css.faqItemDescription}>
                    {faq?.description}
                  </p>
                )}
              </div>
            )
          }) : (
            <DraftContent draftContent={field_faq} />
          )}
        </div>
      )}

    </section>
  );
};

export default SectionFAQ;